import { multiply, subtract, add, not } from "ramda";
import config, { fixedLiterages } from "../coatingAreaConfig";

const double = multiply(2);

const windowArea = (area) => multiply(Number(area.windows), 1.4);
const doorArea = (area) => multiply(Number(area.windows), 1.6);

const threeDimensionalArea = (area) =>
  multiply(
    Number(area.height),
    double(add(Number(area.width), Number(area.length)))
  );

const horizontalTwoDimensionalArea = (area) =>
  multiply(Number(area.length), Number(area.width));

const verticalTwoDimensionalArea = (area) =>
  multiply(Number(area.width), Number(area.height));

const sqMetersByType = {
  timberWallsRoom: (area) =>
    subtract(threeDimensionalArea(area), windowArea(area)),
  timberWall: (area) =>
    subtract(verticalTwoDimensionalArea(area), windowArea(area)),
  timberDoor: verticalTwoDimensionalArea,
  benchTop: horizontalTwoDimensionalArea,
  miscFurniture: threeDimensionalArea,
  concreteFloor: horizontalTwoDimensionalArea,
  floorHouse: horizontalTwoDimensionalArea,
  floorRoom: horizontalTwoDimensionalArea,
  deck: horizontalTwoDimensionalArea,
  cladding: (area) =>
    subtract(threeDimensionalArea(area), add(windowArea(area), doorArea(area))),
  outdoorFurniture: threeDimensionalArea,
  windows: windowArea,
};

export const isConfigurable = (area) => config[area.type].configurable;

export const isNotConfigurable = (area) => not(isConfigurable(area));

export const getCoatMultiplier = (area) => multiply(config[area.type].coats);

export const getSqMeters = (area) => sqMetersByType[area.type](area);

export const getSqMetersMultipliedByCoats = (area) =>
  getCoatMultiplier(area)(getSqMeters(area));

export const getFixedLiterage = (area) => fixedLiterages[area.type];
